import { Box } from "arkh";
import React, { useCallback } from "react";
import { graphql, useMutation } from "react-relay";
import { OrgButton } from "../../../OrgButton";
import { useIntlTokens } from "../../../../../components/mobile/useIntlTokens";

import { useAlert } from "../../../../../common/Alert";
import { useIntl } from "react-intl";
import { WorkspaceSignalEditMainDeleteMutation } from "./__generated__/WorkspaceSignalEditMainDeleteMutation.graphql";

export function DeleteDraft(props: { id: string; onDeleted: () => void }) {
  const intl_token = useIntlTokens();
  const [deleteMutation, pendingDelete] =
    useMutation<WorkspaceSignalEditMainDeleteMutation>(graphql`
      mutation WorkspaceSignalEditMainDeleteMutation($id: ID!) {
        signalWorkspace(id: $id) {
          delete {
            id
          }
        }
      }
    `);

  const Alert = useAlert();

  const intl = useIntl();

  const title = intl.formatMessage({
    defaultMessage: "Delete Draft",
    description: "Workspace Signal Edit Delete Draft Title",
  });
  const body = intl.formatMessage({
    defaultMessage:
      "Do you really want to delete your draft? Once removed, it cannot be recovered.",
    description: "Workspace Signal Edit Delete Draft Body",
  });

  const requestDelete = useCallback(() => {
    Alert.alert(title, body, [
      {
        text: intl_token.Cancel,
        style: "cancel",
      },
      {
        text: intl_token.Delete,
        style: "destructive",
        onPress: () => {
          deleteMutation({
            variables: {
              id: props.id,
            },
            onCompleted: props.onDeleted,
          });
        },
      },
    ]);
  }, [
    Alert,
    body,
    deleteMutation,
    intl_token.Cancel,
    intl_token.Delete,
    props.id,
    props.onDeleted,
    title,
  ]);
  return (
    <Box style={{ flexDirection: "row" }}>
      <OrgButton
        loading={pendingDelete}
        backgroundColor="transparent"
        tintColor="negative"
        icon="trash"
        iconPostion="right"
        title={intl_token.Delete}
        onPress={requestDelete}
      />
    </Box>
  );
}
